<template>
    <div>
        <div class="dropdown">
            <button class="btn btn-light help-button p-1" type="button" :id="computed_id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-info-circle pt-1"></i>
            </button>
            <div class="dropdown-menu" :aria-labelledby="computed_id">
                <a v-if="youtubeCodigo"
                    class="dropdown-item" href="#" @click="active_codigo = true">
                    <i class="fab fa-youtube mr-2 text-danger"></i>
                    Video tutorial código
                </a>
                <a v-if="youtubeSesion"
                    class="dropdown-item" href="#" @click="active_sesion = true">
                    <i class="fab fa-youtube mr-2 text-danger"></i>
                    Video tutorial sesión
                </a>
                <a v-if="youtubeId || youtubeSrc"
                    class="dropdown-item" href="#" @click="active = true">
                    <i class="fab fa-youtube mr-2 text-danger"></i>
                    Video tutorial
                </a>
                <a v-if="pdfId || pdfSrc"
                    class="dropdown-item" href="#" @click="pdfClick">
                    <i class="fas fa-file-pdf mr-2 text-info"></i>
                    Documentación
                </a>
            </div>
        </div>
        <div v-if="youtubeId || youtubeSrc || youtubeCodigo || youtubeSesion"
            :id="computed_id+'-modal'" class="modal fade component-modal">
            <vs-dialog not-close auto-width not-padding v-model="active_codigo">
                <div class="con-image">
                    <iframe 
                        class="iframe-responsivo"
                        width="560"
                        height="750"
                        :src="youtubeCodigo" 
                        title="YouTube video player"
                        frameborder="0"
                        allowfullscreen>
                    </iframe>
                </div>
            </vs-dialog>
            <vs-dialog not-close auto-width not-padding v-model="active_sesion">
                <div class="con-image">
                    <iframe 
                        class="iframe-responsivo"
                        width="560"
                        height="750"
                        :src="youtubeSesion" 
                        title="YouTube video player"
                        frameborder="0"
                        allowfullscreen>
                    </iframe>
                </div>
            </vs-dialog>
            <vs-dialog not-close auto-width not-padding v-model="active">
                <div class="con-image">
                    <iframe 
                        class="iframe-responsivo"
                        width="560"
                        height="750"
                        :src="youtubeId" 
                        title="YouTube video player"
                        frameborder="0"
                        allowfullscreen>
                    </iframe>
                </div>
            </vs-dialog>
        </div>
        <div v-if="pdfId || pdfSrc"
            :id="computed_id+'-pdf'" class="modal fade component-modal">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-body p-0" style="background: black">
                        <div class="text-center">
                            <iframe :src ="'/help/pdf/'+pdfId+'.pdf'"
                                width="100%" 
                                height="600px">
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'youtubeId',
        'youtubeSrc',
        'pdfId',
        'pdfSrc',
        'codigo',
        'youtubeCodigo',
        'youtubeSesion'
    ],
    data(){
        return{
            active: false,
            active_codigo: false,
            active_sesion: false
        }
    },
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('help-button-' + this._uid);
            } else {
                return this.id;
            }
        },
    },
    mounted() {
        const vm = this;
        const PdfModal = $('#'+vm.computed_id+'-pdf');
        const VideoModal = $('#'+vm.computed_id+'-modal');
        const VideoIFrame = $('#'+vm.computed_id+'-iframe');

        VideoModal.on('hide.bs.modal', function (event) { 
            VideoIFrame.each(function(index) {
                $(this).attr('src', $(this).attr('src'));
                return false;
            });
        });
    },
    methods: {
        videoClick() {
            const VideoModal = $('#'+this.computed_id+'-modal');
            VideoModal.modal('show');
        },
        pdfClick() {
            const PdfModal = $('#'+this.computed_id+'-pdf');
            PdfModal.modal('show');
        },
    },
}
</script>

<style scoped>
.contenedor-responsivo {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
}
.iframe-responsivo {
    width: 660px;
    height: 420px;
    border: 0;
}
</style>